import { FC } from 'react';
import { useGetCurrentUserQuery, useGetLoginStreakQuery } from '@teachur/http-client';
import fireIcon from '@assets/dashboard/streak-fire.png';
import booksIcon from '@assets/dashboard/streak-books.png';
import { countPassedThisMonth } from '../../lib/courseSnapshot';

interface StatBlockProps {
  label: string;
  value: number;
  unit: string;
  icon: string;
  className: string;
}

const StatBlock: FC<StatBlockProps> = ({ label, value, unit, icon, className }) => (
  <div className={`relative flex flex-1 flex-col justify-between gap-3 p-5 ${className}`}>
    <p className="bold m-0 [font-family:var(--font-montserrat)] text-[10px] tracking-[1.8px] text-(--neutral-black-NB900) uppercase">
      {label}
    </p>
    <p className="m-0 flex items-baseline gap-1.5 text-(--neutral-black-NB900)">
      <span className="bold text-3xl">{value}</span>
      <span className="l4 bold">{unit}</span>
    </p>
    <img src={icon} alt="" aria-hidden className="absolute right-5 bottom-5 size-12" />
  </div>
);

export const ActivityStatsCard: FC = () => {
  const { data: user } = useGetCurrentUserQuery();
  const { data: streak } = useGetLoginStreakQuery();

  const streakDays = Math.max(streak?.loginStreak ?? 0, 1);
  const passedThisMonth = countPassedThisMonth(user?.userCourses ?? [], new Date());

  return (
    <section className="flex w-full flex-col overflow-hidden rounded-[20px] bg-(--neutral-white-NW1000) shadow-[0_0_2px_rgba(0,0,0,0.15)] sm:flex-row lg:w-58.75 lg:flex-col">
      <StatBlock
        label="Current streak"
        value={streakDays}
        unit={streakDays === 1 ? 'day' : 'days'}
        icon={fireIcon}
        className="bg-(--primary-O200)"
      />
      <StatBlock
        label="This month"
        value={passedThisMonth}
        unit={passedThisMonth === 1 ? 'course' : 'courses'}
        icon={booksIcon}
        className="bg-(--neutral-white-NW1000)"
      />
    </section>
  );
};
